<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Textarea/NewDTextareaEditor'
export default {
  name: 'NewDAbstractEditor',
  extends: compoment
}
</script>
